import React from 'react';
import {Button, Stack} from '@mui/material';
import {AppointmentBookingEnum, FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';
import {EmptySearchState} from 'presentation/components';
import {ChatRoomsEnum} from 'presentation/constants';
import {useBookingSummary} from 'presentation/modules/booking/shared/hooks/useBookingSummary';
import {ChangeFlowVariantEnum} from 'presentation/modules/booking/shared/ui/components/ChangeFlowDialog/constants';
import {useCallChatRoom} from 'presentation/pages';
import {translations} from 'presentation/translations-new';
import {Loading} from 'presentation/components/Loading/Loading';

const {noResults, callToChat, changeLocation} = translations['pt-br'].commons;
const {districtFlow} = translations['pt-br'].privateFlow.bookingFlow;

export function ExamDistrictNotFoundState() {
	const {callChatRoom, IS_LOADING: callChatRoomIsLoading} = useCallChatRoom();
	const {handleChangeModals} = useBookingSummary();

	return (
		<EmptySearchState
			dataTagId={FinishWithoutCompleteFlowEnum.SEM_BAIRRO_DISPONIVEL}
			title={noResults}
			description={districtFlow.notFoundModal.descriptionExam}>
			<Stack gap={2}>
				<Button
					variant="contained"
					size="large"
					data-tag-id={AppointmentBookingEnum.CLICK_ALTERAR_LOCAL_ATENDIMENTO_AGENDAMENTO}
					onClick={() => handleChangeModals(ChangeFlowVariantEnum.LOCATION)}>
					{changeLocation}
				</Button>
				<Button
					variant={'outlined'}
					size="large"
					data-tag-id={AppointmentBookingEnum.CLICK_FALAR_COM_ATENDIMENTO_AGENDAMENTO}
					onClick={async () => await callChatRoom(ChatRoomsEnum.EXAMS)}
					disabled={callChatRoomIsLoading}
					endIcon={callChatRoomIsLoading ? <Loading size={16} color="inherit" /> : null}>
					{callToChat}
				</Button>
			</Stack>
		</EmptySearchState>
	);
}
